(function () {
  function cartNoteTrimmed() {
    var areas = document.querySelectorAll('textarea[name="note"], input[name="note"]');
    for (var i = 0; i < areas.length; i++) {
      var v = (areas[i].value || '').trim();
      if (v !== '') return v;
    }
    return '';
  }

  function setAllInvoiceCheckboxes(checked) {
    document.querySelectorAll('[data-ee-invoice-checkbox]').forEach(function (el) {
      el.checked = checked;
    });
  }

  function postWantsInvoice(yes) {
    var wants = yes ? 'yes' : '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { wants_invoice: wants } }),
    });
  }

  /** Drop stale wants_invoice when order note is empty (server + UI). */
  function clearInvoiceIfNoNoteFromCart() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var note = ((cart.note || '') + '').trim();
        var inv = cart.attributes && String(cart.attributes.wants_invoice || '');
        if (inv === 'yes' && !note) {
          return postWantsInvoice(false).then(function () {
            setAllInvoiceCheckboxes(false);
          });
        }
      })
      .catch(function () {});
  }

  document.body.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-ee-invoice-checkbox]')) return;
    var wants = t.checked ? 'yes' : '';
    document.querySelectorAll('[data-ee-invoice-checkbox]').forEach(function (el) {
      if (el !== t) el.checked = t.checked;
    });
    postWantsInvoice(!!wants).catch(function () {});
  });

  document.body.addEventListener(
    'blur',
    function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('textarea[name="note"], input[name="note"]')) return;
      if (t.value.trim() !== '') return;
      var anyChecked = false;
      document.querySelectorAll('[data-ee-invoice-checkbox]').forEach(function (el) {
        if (el.checked) anyChecked = true;
      });
      if (!anyChecked) return;
      setAllInvoiceCheckboxes(false);
      postWantsInvoice(false).catch(function () {});
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearInvoiceIfNoNoteFromCart);
  } else {
    clearInvoiceIfNoNoteFromCart();
  }
})();
